import Vue from 'vue';
import App from './App.vue';

// Date and Time library
import '@/plugins/moment';

import store from './store/store';
import router from '@/routes/router';

// Component library
import '@/plugins/vuesax';

// Animate.css
import 'animate.css';

// Way to fake ajax requests
// import './fake-db/index.js'

// Globally Registered Components
import './globals.js';

// Styles: SCSS
import '@/assets/scss/main.scss';

// Tailwind
import '@/assets/css/main.css';

// Load Script
import '@/plugins/loadScript';

// Filters
import '@/filters/filters';

// Clipboard
import '@/plugins/vue-clipboard';

// Promise based dialog system
import '@/plugins/dialog';

import { APIHelper, AuthUser, Analytics } from '@archistarai/auth-frontend';
Vue.prototype.$APIHelper = APIHelper;
Vue.prototype.$authUser = AuthUser;

// Gesture control library
import '@/plugins/hammer';

// Form validation
import '@/plugins/vee-validate';

// Feather icons
require('./assets/css/iconfont.css');

Vue.config.productionTip = false;

const enterprise = require('ag-grid-enterprise');
enterprise.LicenseManager.setLicenseKey(
  'CompanyName=Archistar,LicensedApplication=Archistar,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-008944,ExpiryDate=16_July_2021_[v2]_MTYyNjM5MDAwMDAwMA==c1f2799d1acb4bb97ca3536bfe19f5ac'
);

const app = new Vue({
  data() {
    return {
      appEnv: process.env.NODE_ENV
    };
  },
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');

if (process.env.VUE_APP_ENV === 'production') {
  // Prod settings
  Analytics.admin.init();
} else {
  // Dev settings
  window.app = app;
}
